import { InputStateInterface } from 'common/module/input/state.interface';
import { InputValidatorInterface } from 'common/module/input/validator.interface';

export class InputValidatorNumberRange implements InputValidatorInterface {
  /**
   * Constructor
   */
  constructor(
    protected message: string,
    protected ratingMin: number,
    protected ratingMax: number = Infinity,
    protected excludeMin?: boolean
  ) {}

  /**
   * @inheritDoc
   */
  public getError(value: number, context: { [key: string]: InputStateInterface }): string {
    if (this.excludeMin) {
      if (value <= this.ratingMin || value > this.ratingMax) {
        return this.message
          .replace('{range-from}', String(this.ratingMin))
          .replace('{range-to}', String(this.ratingMax));
      }

      return '';
    }

    if (value < this.ratingMin || value > this.ratingMax) {
      return this.message.replace('{range-from}', String(this.ratingMin)).replace('{range-to}', String(this.ratingMax));
    }

    return '';
  }
}
